// @flow

import React from 'react';
import Box from 'sail/Box';
import Group from 'sail/Group';
import Button from 'sail/Button';
import {Intro} from 'sail/Text';
import {InlineLink} from 'sail/InlineLink';
import {TextArea} from 'sail/Input';
import {sanitizePII, wait} from 'docs/util';
import {useApi} from 'docs/data';

type FormState = 'initial' | 'asking' | 'submitting' | 'submitted' | 'hide';

type ShareFeedbackProps = {
  videoID: string,
};

export const ShareFeedback = (videoID: ShareFeedbackProps) => {
  const [formState, setFormState] = React.useState<FormState>('initial');

  const [text, setText] = React.useState('');
  const {api} = useApi();

  const handleSubmit = () => {
    if (text.trim().length < 1) {
      return;
    }

    const payload = {
      text: sanitizePII(text, '[REDACTED]'),
      videoID,
      path: window.location.pathname,
    };

    // Send to CSAT endpoint to pipe to Slack channel
    setFormState('submitting');
    return api
      .sendCsatFeedback(payload)
      .catch(() => null)
      .then(() => {
        return 1000;
      })
      .then(wait)
      .then(() => {
        setFormState('submitted');
        return 4000;
      })
      .then(wait)
      .then(() => {
        setFormState('hide');
      });
  };

  if (formState === 'initial') {
    return (
      <InlineLink onClick={() => setFormState('asking')}>
        Share feedback
      </InlineLink>
    );
  } else if (formState === 'asking' || formState === 'submitting') {
    return (
      <Box
        margin={{top: 32}}
        padding={{top: 32}}
        divider={{color: 'light', width: 1, side: 'top'}}
      >
        <Group spacing={16}>
          <Intro>What did you think of this guide format?</Intro>
          <TextArea
            onChange={(val) => {
              setText(val);
            }}
            placeholder=""
            resizeable
            value={text}
            width="long"
          />
          <Group
            direction="horizontal"
            spacing={32}
            alignItems="center"
            justifyContent="space-between"
          >
            <Button
              label={'Submit'}
              color="white"
              onClick={handleSubmit}
              pending={formState === 'submitting'}
            />
          </Group>
        </Group>
      </Box>
    );
  } else if (formState === 'submitted') {
    return (
      <Box
        margin={{top: 32}}
        padding={{top: 32}}
        divider={{color: 'light', width: 1, side: 'top'}}
      >
        <Intro>Thank you for helping improve Stripe's documentation!</Intro>
      </Box>
    );
  } else {
    return null;
  }
};
